import * as React from 'react';
import {
  withStyles,
  WithStyles,
} from '@material-ui/core';
import Button from '@components/common/button/Button';
import TranslateNew from '@translate/TranslateNew';
import {connect} from 'react-redux';
import * as EconomyActions from '@services/economy/economy.actions';
import * as NotesActions from '@services/sharednote/sharednote.actions';
import {
  BoxedRow,
  Col,
  CustomCheckbox,
  CustomDialogContent,
  CustomSelectInverted,
  CustomTextFieldInvertedP,
  NoPrice,
  Row,
  StyledInputAdornment,
  StyledLabel,
  dialogStyles,
} from '../DialogComponens';
import { EcoRepeat, IEcoSplit, INewEcoAgreement } from '@app-types/websocket/economy.types';
import { ISharedNote } from '@app-types/websocket/sharedinfo.types';
import { IFamilyMember } from '@app-types/websocket/family.types';
import { FamilyMemberType } from '@services/family/family.constants';

const tn = TranslateNew.getInstance();

interface IProps extends WithStyles<typeof dialogStyles>{
  next: () => void;
  currency:string;
  miltipleKids:boolean;
  split:IEcoSplit[];
  family:IFamilyMember[];

  newAgreement: (values:INewEcoAgreement) => void;
  newAccount: (values:ISharedNote) => void;
}

interface IState {
  price:number;
  setPrice:boolean;
  service:string;
  first:boolean;
}

enum StreamingService {
  NOTHING = 'NOTHING',
  ATV = 'ATV',
  CMORE = 'CMORE',
  DISNEY = 'DISNEY',
  GPLAY = 'GPLAY',
  HBO = 'HBO',
  NETFLIX = 'NETFLIX',
  PRIME = 'PRIME',
  SPOTIFY = 'SPOTIFY',
  STORYTEL = 'STORYTEL',
  VIA = 'VIA',
  DISCO = 'DISCO',
  OTHER = 'OTHER',
}

class StepSubs extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);

    this.state = {
      price:0,
      setPrice: false,
      service:"NOTHING",
      first:true,
    };
    
  }

  public render() {
    const { next } = this.props;
    const {price, service} = this.state;

    return (<>
        <CustomDialogContent >
          <BoxedRow style={{fontWeight: 500, fontSize: '17px'}}>
            {this.state.first
              ?tn.lang.agreGuideStream(this.props.miltipleKids)
              :tn.lang.agreGuideStreamMore}
            
          </BoxedRow>
          <BoxedRow style={{ flex: 1 }}>
            <StyledLabel htmlFor="service" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', flex: 1, gap:'8px', }}>
              <span>{tn.lang.service}</span>
            </StyledLabel>
            <Col>
            <CustomSelectInverted
                name="service"
                value={service}
                onChange={(e) => this.selectService(e)}
                displayEmpty={true}
                disableUnderline={true}
                data={Object.values(StreamingService).map((option: string) => ({value:option, element:<>{this.serviceName(option,false)}</>}))}
              />
            </Col>
          </BoxedRow>
          <BoxedRow>
            <Col style={{ flex: 1, alignItems: 'flex-start', justifyContent: 'center', minWidth: 110 }}>
              <StyledLabel htmlFor="setPrice">{tn.lang.agreementEstimatePrice}
                <CustomCheckbox color="default" id="setPrice" checked={this.state.setPrice} 
                  onClick={() => this.setState({setPrice:!this.state.setPrice})}/>
              </StyledLabel>
            </Col>
            <Col>
            {this.state.setPrice
              ?<CustomTextFieldInvertedP
                name="amount"
                id="amount"
                value={(price === undefined || price===0)?"":price}
                placeholder={(price === undefined || price===0)?"0":undefined}
                onChange={(e) => this.setState({price:(e.target.value.length > 0?Number.parseInt(e.target.value,10):0)})}
                type="number" 
                inputMode="numeric"
                tabIndex={1}
                autoComplete="off"
                InputProps={{
                  disableUnderline: true,
                  endAdornment: (<StyledInputAdornment position="end" disableTypography={true}>{this.props.currency}</StyledInputAdornment>),
                }}
                InputLabelProps={{ shrink: false }}
              />
              :<NoPrice>{tn.lang.agreementNoPrice}</NoPrice>
            }
              
            </Col>
          </BoxedRow>
        </CustomDialogContent>
        <Row style={{justifyContent: 'flex-end', padding: '20px'}}>
          <Button onClick={() => next()} color='default' variant='contained' size="large">
            {tn.lang.no}
          </Button>
          <Button onClick={() => this.createNew()} color='primary' variant='contained' size="large">
            {tn.lang.add}
          </Button>
        </Row></>
    );
  }

  private selectService(e:React.ChangeEvent<{name?: string | undefined;value: unknown;}>) {
    const v:string = (typeof e.target.value === 'string')? e.target.value:"OTHER"; 
    this.setState({service:v, price:this.servicePrice(v), setPrice:true});
  }

  private createNew() {
    const newAgreement:INewEcoAgreement = {
      title: this.serviceName(this.state.service, true),
      children: [],
      currency: this.props.currency,
      images: [],
      responsible: [],
      repeat: EcoRepeat.MONTHLY,
      split: this.props.split,
      amount: this.state.setPrice?this.state.price:0,
      autoAccept: true,
    };
    
    this.props.newAgreement(newAgreement);

    const newSharedAccount : ISharedNote = {
      serviceName:this.serviceName(this.state.service, true),
      accountName: "",
      accountPassword: "",
      visibleFor:this.props.family
        .filter((mem)=>( mem.role === FamilyMemberType.PARENT))
        .map((mem)=>mem.id),
      seenBy:[],
      noteId:-1000,
      icon:this.serviceIcon(this.state.service),
    };

    this.props.newAccount(newSharedAccount);

    this.setState({first:false, price:0, service:"NOTHING", setPrice:false});
  }

  private serviceName(service:string, desc:boolean):string {
    switch (service) {
      case StreamingService.ATV:
        return "Apple TV";
      case StreamingService.CMORE:
        return "C More";
      case StreamingService.DISCO:
        return "Discovery";
      case StreamingService.DISNEY:
        return "Disney+";
      case StreamingService.GPLAY:
        return "Google Play";
      case StreamingService.HBO:
        return "HBO";
      case StreamingService.NETFLIX:
        return "Netflix";
      case StreamingService.PRIME:
        return "Prime Video";
      case StreamingService.SPOTIFY:
        return "Spotify";
      case StreamingService.STORYTEL:
        return "Storytel";
      case StreamingService.VIA:
        return "Viaplay";
      case StreamingService.OTHER:
        if (desc) {return tn.lang.otherStreamingServiceDesc;}
        else {return tn.lang.otherStreamingService;}
      default :
        if (desc) {return tn.lang.otherStreamingServiceDesc;}
        else {return tn.lang.selectService;}
  }
  }

  private servicePrice(service:string):number {
    switch (service) {
      case StreamingService.ATV:
        return 89;
      case StreamingService.CMORE:
        return 149;
      case StreamingService.DISCO:
        return 179;
      case StreamingService.DISNEY:
        return 89;
      case StreamingService.GPLAY:
        return 59;
      case StreamingService.HBO:
        return 99;
      case StreamingService.NETFLIX:
        return 99;
      case StreamingService.PRIME:
        return 59;
      case StreamingService.SPOTIFY:
        return 199;
      case StreamingService.STORYTEL:
        return 179;
      case StreamingService.VIA:
        return 149;
      case StreamingService.OTHER:
        return 99;
      default :
        return 99;
    }
  }

  private serviceIcon(service:string):string {
    switch (service) {
      case StreamingService.ATV:
        return "atv.png";
      case StreamingService.CMORE:
        return "cmore.png";
      case StreamingService.DISCO:
        return "disco.png";
      case StreamingService.DISNEY:
        return "disney.png";
      case StreamingService.GPLAY:
        return "gplay.png";
      case StreamingService.HBO:
        return "hbo.png";
      case StreamingService.NETFLIX:
        return "netflix.png";
      case StreamingService.PRIME:
        return "prime.png";
      case StreamingService.SPOTIFY:
        return "spotify.png";
      case StreamingService.STORYTEL:
        return "storytel.png";
      case StreamingService.VIA:
        return "via.png";
      case StreamingService.OTHER:
        return "streaming-tv-app.png";
      default :
        return "streaming-tv-app.png";
    }
  }
}

function mapStateToProps(state: any) {
  const userId = state.user.session.data.id;

  return {
    userId,
    family: state.family.family,
  };
}

const mapDispatchToProps = {
  newAgreement: EconomyActions.newAgreement,
  newAccount : NotesActions.updateSharedNote,
};


export default connect(mapStateToProps,mapDispatchToProps)(withStyles(dialogStyles)(StepSubs));



// WEBPACK FOOTER //
// ./src/components/economy/setup/StepSubs.tsx